export const Badges = {
  "Special Update": "bg-[#C4DBEC]",
  "Special Report": "bg-[#C4ECCC]",
  Video: "bg-[#FFB4B4]",
};
